
import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { loadStay } from '../store/actions/stay.actions'
import { Map } from '../cmps/StayDetailsCmps/Map'
import { GuestFavorite } from '../cmps/StayDetailsCmps/GuestFavorie'
import { StayGallery } from '../cmps/StayDetailsCmps/StayGallery'
import { StayReservation } from '../cmps/StayDetailsCmps/StayReservation'
import { ScrollHeader } from '../cmps/StayDetailsCmps/ScrollHeader'
import { Amenities } from '../cmps/StayDetailsCmps/Amenities'
import {
  pluralize,
  calculateAverageRating,
  getRandomIntInclusive,
  amenityIcons,
  getRandomMonth,
  countStay,
  getRandomStayDescription
} from '../services/util.service'

export function StayDetails() {
  const { stayId } = useParams()
  const stay = useSelector((storeState) => storeState.stayModule.stay)
  const [showScrollHeader, setShowScrollHeader] = useState(false)
  const [searchParams] = useSearchParams()
  const guestCount = JSON.parse(searchParams.get('guests') || '{}')
  const [initialStartDate, setInitialStartDate] = useState(null)
  const [initialEndDate, setInitialEndDate] = useState(null)
  const [showAllReviews, setShowAllReviews] = useState(false)

  useEffect(() => {
    loadStay(stayId)
  }, [stayId])

  useEffect(() => {
    if (stay && stay.dateRange) {
      const [startDateStr, endDateStr] = stay.dateRange.split(' - ')
      setInitialStartDate(new Date(startDateStr))
      setInitialEndDate(new Date(endDateStr))
    }
  }, [stay])

  useEffect(() => {
    const handleScroll = () => {
      const photoSection = document.querySelector('.stay-gallery')
      if (photoSection) {
        const photoSectionBottom = photoSection.getBoundingClientRect().bottom
        setShowScrollHeader(photoSectionBottom <= 0)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (!stay) return <div>Loading...</div>

  const averageRating = calculateAverageRating(stay.reviews)
  const reviewCount = stay.reviews ? stay.reviews.length : 0
  const reviewsToShow = showAllReviews ? stay.reviews : stay.reviews.slice(0, 6)
  function toggleShowAllReviews() {
    setShowAllReviews(!showAllReviews)
  }

  return (
    <section className="stay-details main-layout">
      {showScrollHeader && (
        <ScrollHeader
          price={stay.price}
          rating={averageRating}
          reviewCount={stay.reviews.length}
          stay={stay}
          startDate={stay.startDate}
          endDate={stay.endDate}
          guests={stay.guests}
          numberOfNights={stay.numberOfNights}
          totalPrice={stay.totalPrice}
          taxes={stay.taxes}
          averageRating={averageRating}
        />
      )}
      <header className="stay-header main-layout">
        <h1 className="stay-title">{stay.name}</h1>
        <div className="share-save">
          <button className="share-btn">
            <img src={amenityIcons.share} alt="share-icon" />
            Share
          </button>
          <button className="save-btn">
            <img src={amenityIcons.heart} alt="heart-icon" />
            Save
          </button>
        </div>
      </header>

      <div id="photos" className="active stay-gallery">
        <StayGallery imgUrls={stay.imgUrls} />
      </div>
      <section className="stay-info-container">
        <div className="stay-info">
          <div className="stay-summary">
            <h2>
              {stay.type} in {stay.loc.city}, {stay.loc.country}
            </h2>
            <p className="stay-details-list">
              {pluralize(stay.capacity, 'guest')} ·{' '}
              {pluralize(stay.bedrooms, 'bedroom')} ·{' '}
              {pluralize(stay.beds, 'bed')} · {pluralize(stay.baths, 'bath')}
            </p>
            <div className="rating-reviews">
              <span className="star-icon">
                <img src={amenityIcons.star} alt="Star icon" />
              </span>
              <span className="rating">{averageRating}</span>
              {reviewCount > 0 && (
                <>
                  <span className="separator">·</span>
                  <a href="#reviews" className="reviews-link">
                    {pluralize(reviewCount, 'review')}
                  </a>
                </>
              )}
            </div>
          </div>
          <div className="stay-host-details">
            <GuestFavorite rating={averageRating} reviewCount={stay.reviews.length} />
            <div className="host">
              {stay.host &&
                typeof stay.host === 'object' &&
                stay.host.imgUrl && (
                  <img src={stay.host.imgUrl} alt="Host" className="host-img" />
                )}
              <div className="host-info">
                <div>
                  Hosted by{' '}
                  {typeof stay.host === 'object'
                    ? stay.host.fullname
                    : stay.host}
                </div>
                <div className="host-duration">
                  {getRandomIntInclusive(2, 6)} years hosting
                </div>
              </div>
            </div>
          </div>

          <div className="stay-description">
            <p>{stay.summary}</p>
          </div>
          <div>

            <Amenities amenities={stay.amenities} amenityIcons={amenityIcons} />
          </div>
        </div>
        <div className="stay-reservation">
          <StayReservation
            stay={stay}
            guestCount={guestCount}
            initialStartDate={initialStartDate}
            initialEndDate={initialEndDate}
          />
        </div>
      </section>
      <section id="reviews" className="header-reviews">
        <div className="header">★ {averageRating} · {reviewCount} reviews</div>
        <div className="reviews-container">
          {reviewsToShow.map((review, index) => (
            <article className="review" key={index}>
              <div className="user">
                <img src={review.by.imgUrl} alt="User Avatar" />
                <div className="user-details-txt">
                  <h3>{review.by.fullname}</h3>
                  <p className='review-user'>{getRandomIntInclusive(2, 8)} years on Airbnb</p>
                </div>
              </div>
              <div className="review-txt-date">
                <div className="review-rating">
                  <p>
                    ★★★★★<span></span>
                  </p>
                  <h6>·</h6>
                  {/* <p>{getRandomIntInclusive(1,11)} months ago</p> */}
                  <p>{getRandomMonth()}</p> <h6>·</h6>
                  <p className="stay-description">{getRandomStayDescription()}</p>
                </div>
                <div className="review-content">
                  <p>{review.txt}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
        <button className="show-all-reviews" onClick={toggleShowAllReviews}>
          {showAllReviews ? `Show less` : `Show all ${stay.reviews.length} reviews`}
        </button>
      </section>
      <section id="location">
        <div className="map-container">
          <article>
            <h1>Where you'll be</h1>
            <div className="map">
              <Map stay={stay} />
            </div>
            <div className="city-info">
              {stay.loc.country} · {stay.loc.city} · {stay.loc.address}
            </div>
          </article>
        </div>
      </section>
    </section>
  )
}

